'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _shallowEquals = require('unmutable/lib/shallowEquals');

var _shallowEquals2 = _interopRequireDefault(_shallowEquals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (parcelA, parcelB) {
    var aa = parcelA.raw();
    var bb = parcelB.raw();

    return aa.value === bb.value && aa.key === bb.key && aa.child === bb.child && (0, _shallowEquals2.default)(aa.meta)(bb.meta);
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels-react/lib/util/PureParcelEquals.js
// module id = 733
// module chunks = 35783957827783